<template>
  <div id="main_create_project" class="content_step_nav_container centered">
    <breadcrumbs :items="breadcrumbsComp" />
    <div class="haed">
      <div class="title_btn">
        <!-- <h2 class="title" v-text="'יצירת מכרז' + ' >' + ' שלב ' + (currentStep == 0 ? '1' : currentStep)"></h2>  -->
        <h2 class="title">יצירת מכרז</h2> 
        <router-link :to="mainPageLink" class="exit_btn">יציאה מהמכרז</router-link>
      </div>
      <ul class="steps">
        <div class="arrow_container" v-show="currentStep > 1" @click="moveStep('back')">
          <div class="arrow_right_icon icon"></div>
        </div>
        <li class="step" v-for="step in steps" :class="{active: currentStep === step.stepNum || ( step.stepNum === 1 && currentStep === 0)}" :key="step.stepNum">
          <span class="num" v-text="step.stepNum" v-if="currentStep <= step.stepNum"></span>
          <div class="icon_container" v-else>
            <span class="icon check_white_icon"></span>
          </div>
          <span class="name" v-text="step.name"></span>
        </li>
      </ul>
    </div>
    <div class="content">
      <existingDetails ref="currentStep" @startAutoSave="startAutoSave" @next="moveStep('next')" v-if="currentStep === 1 || currentStep === 0" :edit_token="token" />
      <contractManager ref="currentStep" @next="moveStep('next')" v-if="currentStep === 2" :edit_token="token" />
      <lastDetailsPublish ref="currentStep" v-if="currentStep === 3" :edit_token="token" />
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs.vue'
import existingDetails from '../components/createProject/existingDetails'
import lastDetailsPublish from '../components/createProject/lastDetailsPublish'
import contractManager from '../components/createProject/contractManager'

export default {
    components: {existingDetails, lastDetailsPublish, contractManager, Breadcrumbs},
    data() {
        return {
          currentStep: +this.$route.params.step,
          token: (this.$route.params.token ? this.$route.params.token : false),
          saveInterval: null,
          steps: [
            { stepNum: 1, name: this.get_word('create_prj_1', true) },
            { stepNum: 2, name: this.get_word('create_prj_contract', true) || 'ניהול חוזה' },
            { stepNum: 3, name: this.get_word('create_prj_5', true) },
          ]
        }
    },
    computed: {
      breadcrumbsComp() {
        return this.steps.reduce((acc, step) => {
          if (this.currentStep >= step.stepNum) {
            acc.push({
              label: step.name,
              path: `/create_project/${step.stepNum}/${this.token}`
            });
          }
          return acc;
        }, [
          {label: 'רשימת מכרזים', path: '/projects_manager'}, 
          {label: 'יצירת מכרז', path: `/create_project/1/${this.token}`}, 
        ]);
        // return [
        //   {label: 'רשימת מכרזים', path: '/projects_manager'}, 
        //   {label: 'יצירת מכרז', path: '/create_project'}, 
        //   {label: this.steps.find(item => item.stepNum === (this.currentStep || 1))?.name, path: '/create_project'}
        // ];
      }
    },
    methods: {

      moveStep(to){
        let step = this.currentStep;
        if (to == "back") {
          if (step && +step > 1 ) {
            step--
          } else {
            return;
          }
        } else {
          if(step <= 0) step = 2;
          else {
            step++;
          }
        }
       
        if(!this.token){
          this.token = localStorage.getItem('project_token');
          this.$router.push('/create_project/'+step+'/'+ localStorage.getItem('project_token')) ;
        }
        else{
          this.$router.push('/create_project/'+ step +'/'+ this.token) ;
        }

        // this.currentStep = step;
      },

      startAutoSave() {
        if (this.saveInterval) {
          clearInterval(this.saveInterval);
        }
        
        this.saveInterval = setInterval(() => {
          console.log('autoSave');
          
          // Emit event to current active component to trigger save
          this.$refs.currentStep?.autoSave?.();
        }, 1000 * 60); // Save every minute

      },

      stopAutoSave() {
        if (this.saveInterval) {
          clearInterval(this.saveInterval);
          this.saveInterval = null;
        }
      }
    },

    mounted(){
      // if(localStorage.getItem('project_token') && localStorage.getItem('project_token') != '' &&!this.token &&  (this.currentStep == 1 || this.currentStep == 0 || !this.currentStep))
      // {
      //   this.confirm(this.get_word('alredy_sign'), this.get_word('alredy_sign_confirm'),this.get_word('alredy_sign_cancel')).then((result) => {
      //     if (result) {
      //               this.$router.push('/create_project/'+(this.currentStep > 0 ? this.currentStep : 1 )+'/'+ localStorage.getItem('project_token')) ;
      //             } else {
      //                 localStorage.removeItem('project_token');
      //             }
      //     });
      // }
      // else
       if(localStorage.getItem('project_token') && localStorage.getItem('project_token') != '' && !this.token &&  this.currentStep > 1 )
      {
        this.$router.push('/create_project/'+(this.currentStep > 0 ? this.currentStep : 1 )+'/'+ localStorage.getItem('project_token')) ; 
      }
      if(this.currentStep > 1) this.startAutoSave();
    },


    beforeMount(){
      const res = this.checkPerms();
      if(!res || res == 'entrepreneur'){
        this.$router.push('/');  
      }
    },

    beforeUnmount() {
      this.stopAutoSave();
    },

    watch: {
      currentStep() {
        // Restart auto-save timer when step changes
        this.startAutoSave();
      }
    }
}
</script>

<style lang="scss" scoped>
#main_create_project { }
</style>